import { render, staticRenderFns } from "./ArchivosHistorialGrua.vue?vue&type=template&id=ab8264d6&"
import script from "./ArchivosHistorialGrua.vue?vue&type=script&lang=js&"
export * from "./ArchivosHistorialGrua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports